<template>
  <div>
    <common-table
        :table-columns="tableColumns"
        :url="url"
        :operate="operate"
        :form-fields="formFields"
        :permission="permission"
        :buttons="buttons"
        :searchs="searchs"
        @returnId="returnId"
        ref="table"
    ></common-table>
    <div class="dialog">
      <el-dialog
          title="剪辑"
          :visible.sync="batchVisible"
          custom-class="common-dialog"
          :close-on-click-modal="false"
          @close="resetForm('batchForm')"
          width="30%"
      >
        <div class="dialog_body">
          <el-form
              label-position="right"
              status-icon
              label-width="90px"
              :model="batchForm"
              ref="batchForm"
          >
            <el-form-item
                label="剪辑任务名称"
                prop="clipName"
                :rules="[{ required: true, message: '剪辑任务名称不能为空', trigger: 'blur'}]"
            >
              <el-input
                  v-model="batchForm.clipName"
                  placeholder="请输入剪辑任务名称"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitBatch('batchForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'DouYinProductImage',
  components: {CommonTable},
  data() {
    return {
      batchVisible: false,
      batchForm: {
        ids: '',
        clipName:'',
      },
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'productName',
        placeholder: '商品名称',
        type: 'input'
      },{
        name: 'productId',
        placeholder: '商品ID',
        type: 'input'
      },{
        name: 'type',
        placeholder: '选品方式',
        type: 'select',
        selectValue: [{
          key: 1,
          value: '手动选品',
        }, {
          key: 2,
          value: '自动选品',
        }, {
          key: 3,
          value: '自动发布',
        }]
      },],
      permission: {
        add: 'douYinProductImage:add',
        update: 'douYinProductImage:update',
        delete: 'douYinProductImage:delete',
        deleteBatch: 'douYinProductImage:deleteBatch'
      },
      url: {
        get: '/douYinProductImage/listByCondition',
        add: '/douYinProductImage/add',
        update: '/douYinProductImage/update',
        delete: '/douYinProductImage/delete',
        delete_batch: '/douYinProductImage/deleteBatch',
        status: '/douYinProductImage/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      },
        {
          field: 'productId',  // 字段名
          label: '商品ID',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'productName',
          label: '商品名称',
          show: true,
          width: '',
        }, {
          field: 'imageUrl',  // 字段名
          label: '图片',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          img: true,
          detail:true,
        }, {
          field: 'type',  // 字段名
          label: '选品方式',  // 字段显示名称
          sort: false,  // 是否排序
          show: {
            type: 'select',
          },
          selectData: [{
            id: 1,
            name: '手动选品'
          }, {
            id: 2,
            name: '自动选品'
          }, {
            id: 3,
            name: '自动发布'
          }],
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            isEdit: true
          },{
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'productId',  // 字段名
            label: '商品ID',  // 字段显示名称
            type: 'input',
            placeholder: '请输入商品ID',
            rules: [
              {required: false, message: '商品ID不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'imageUrl',  // 字段名
            label: '图片URL',  // 字段显示名称
            type: 'input',
            placeholder: '请输入图片URL',
            rules: [
              {required: false, message: '图片URL不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'type',
            label: '选品方式：',
            type: 'select',
            placeholder: '请选择选品方式',
            rules: [{required: true, message: '请选择选品方式', trigger: 'blur'}],
            selectData: [{
              id: 1,
              name: '手动选品'
            },  {
              id: 2,
              name: '自动选品'
            }],
            // add: true,
            update: true,
            filterable: true,
          }
        ]
      },
      operate: [],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '去剪辑',
        permission: 'cuttingTask:update',
        click: () => {
          console.log(this.selectIds)
          if (this.selectIds.length <= 0) {
            this.$message.warning('请选中要发布的数据')
            return
          }
          this.batchForm.ids = this.selectIds.join(",")
          this.batchVisible = true
        }
      }],
    }
  },
  methods: {
    returnId(data) {
      this.selectIds = data;
      console.log(this.selectIds)
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitBatch(formName) {
      console.log(this.batchForm,"123123")
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.post({
            url: '/cuttingTask/batchCutting/2' ,
            data: this.batchForm,
            confirm: '确定批量加入剪辑任务？',
            success: (res) => {
              if (res.code === 0) {
                message.success("剪辑任务加入成功");
                this.batchVisible = false;
                this.$refs.table.getData()
              } else {
                message.error(res.msg);
              }
            }
          })
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
